import React from 'react';
import { useSelector } from 'react-redux';
import {classNames} from "../../../../util/util-helpers";

export default function PageFooter(props) {
    const ui = useSelector((state) => state.ui);
    
    return (
        <div
            className={
                classNames(
                    "w-full pl-52 z-30 h-16 flex justify-end items-center gap-3 fixed right-0 px-8 bg-inverse border-tm-gray-300 border-t",
                    ui?.AIChatPosition === 'bottom' && ui?.isAIChatVisible 
                        ? "footer--with-bottom-chat" 
                        : "bottom-0"
                )
            }
        >
            {props.htmlBefore}

            {props.actionSubmit && (
                <button
                    data-name="submit-button-shortcut"
                    className="btn btn-primary"
                    disabled={!props.canSubmit}
                    onClick={props.canSubmit ? props.actionSubmit : null}>{props.buttonLabel ?? props.translate('btn.update')}
                </button>
            )}

            {props.actionCancel && (
                <button
                    data-name="cancel-button-shortcut"
                    className="btn btn-outline"
                    disabled={!props.canSubmit}
                    onClick={props.canSubmit ? props.actionCancel : null}
                >
                    {props.cancelButtonLabel ?? props.translate('btn.cancel')}
                </button>
            )}
        </div>
    )
}
